<template>
  <Dropdown :disabled="disabled" theme="teacher-calendar-tooltip">
    <slot />
    <template #popper>
      <div class="flex items-center">
        <SvgIcon
          name="click"
          class="mr-2.5 size-4 text-specialprojectsection"
        />
        <span class="text-[14px] leading-[17px] text-[#949494]">
          Для выбора одной даты кликните дважды
        </span>
      </div>
    </template>
  </Dropdown>
</template>

<script setup>
import { Dropdown } from 'floating-vue';

defineProps({
  disabled: {
    type: Boolean,
    required: false,
  },
});
</script>

<style lang="scss">
.v-popper--theme-teacher-calendar-tooltip {
  .v-popper__inner {
    @apply shadow-[0px_3px_4px_0px_rgba(0,0,0,0.1)] p-2 bg-white-100 rounded;
  }
  .v-popper__arrow-container {
    @apply hidden;
  }
}
</style>
